/**
 * URL utility functions
 */

/**
 * Appends query parameter to URL with correct separator (? or &)
 * @param {string} url - Base URL
 * @param {string} param - Query parameter (e.g., 'foo=bar')
 * @returns {string} URL with appended parameter
 */
export const appendQueryParam = (url, param) => {
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}${param}`
}
